<template>
  <v-card>
    <h1 class="text-pagename text-xs-center">Bank management (All province)</h1>
    <bankTable :weserve_bank="weserve_bank"/>
  </v-card>
</template>

<script>

import axios from "axios";
import { mapState } from "vuex";
import bankTable from "@/components/back-office/Rider/Setting/BankListTable";
export default {
  data() {
    return {};
  },
  components: {
    bankTable
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href:  "/weserve_admin_login/select/"
      },
      {
        text: "Select service",
        disabled: false,
        href:  "/weserve_admin_login/control/" + this.$route.params.province
      },
      {
        text: "Rider",
        disabled: false,
        href:
           "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/rider/riderinhouse"
        // href:
        //    "/weserve_admin_login/control/" +
        //   this.$route.params.province +
        //   "/rider/riderdashboard"
      },
      {
        text: "General",
        disabled: true
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
  created() {},
  computed: {
    ...mapState({
      weserve_bank: state => state.fetchWeserveBank.weserve_bank
    })
  }
};
</script>
